import { useState } from "react";
import { genres } from "@/mocks/home";

export default function GenreCompare() {
  const [activeKey, setActiveKey] = useState(genres[0].key);
  const active = genres.find((g) => g.key === activeKey) ?? genres[0];

  return (
    <section id="genres" className="scroll-mt-20 bg-background-100 py-16 md:py-24">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-3xl text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-800">
            类型对照
          </span>
          <h2 className="mt-4 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
            喜剧片与剧情片，两条不同的路
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            同样是师门与同门的题材，放进喜剧或剧情两种框架里，观感会完全不同。切换下面两个标签，对比它们在节奏、侧重与适合人群上的差别。
          </p>
        </div>

        <div className="mt-10 flex justify-center">
          <div className="inline-flex gap-1 rounded-full border border-background-300 bg-background-50 p-1">
            {genres.map((g) => (
              <button
                key={g.key}
                type="button"
                onClick={() => setActiveKey(g.key)}
                className={
                  activeKey === g.key
                    ? "inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2 text-sm font-medium text-background-50 transition-colors"
                    : "inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-full px-5 py-2 text-sm font-medium text-foreground-700 transition-colors hover:text-primary-700"
                }
              >
                <i className={`${g.icon} text-base`} />
                {g.name}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 overflow-hidden rounded-lg border border-background-200/70 bg-background-50 p-5 md:grid-cols-2 md:p-8">
          <div className="flex flex-col">
            <span className="text-xs font-medium text-secondary-700">{active.summary}</span>
            <h3 className="mt-2 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
              {active.name}
            </h3>

            <dl className="mt-6 space-y-4">
              <div className="rounded-lg bg-background-100 p-4">
                <dt className="flex items-center gap-2 text-sm font-semibold text-foreground-950">
                  <i className="ri-focus-2-line text-primary-600" />
                  侧重什么
                </dt>
                <dd className="mt-2 text-xs leading-relaxed text-foreground-600 md:text-sm">
                  {active.focus}
                </dd>
              </div>
              <div className="rounded-lg bg-background-100 p-4">
                <dt className="flex items-center gap-2 text-sm font-semibold text-foreground-950">
                  <i className="ri-speed-up-line text-primary-600" />
                  节奏如何
                </dt>
                <dd className="mt-2 text-xs leading-relaxed text-foreground-600 md:text-sm">
                  {active.rhythm}
                </dd>
              </div>
              <div className="rounded-lg bg-background-100 p-4">
                <dt className="flex items-center gap-2 text-sm font-semibold text-foreground-950">
                  <i className="ri-user-heart-line text-primary-600" />
                  适合谁看
                </dt>
                <dd className="mt-2 text-xs leading-relaxed text-foreground-600 md:text-sm">
                  {active.audience}
                </dd>
              </div>
            </dl>
          </div>

          <div className="flex flex-col gap-4">
            <div className="h-48 w-full overflow-hidden rounded-lg bg-background-200 md:h-56">
              <img
                src={active.image}
                alt={`${active.name}氛围示意图`}
                className="h-full w-full object-cover object-top"
              />
            </div>
            <div className="rounded-lg bg-secondary-50 p-4">
              <h4 className="flex items-center gap-2 text-sm font-semibold text-secondary-900">
                <i className="ri-lightbulb-line" />
                观看提示
              </h4>
              <ul className="mt-3 space-y-2">
                {active.tips.map((tip) => (
                  <li
                    key={tip}
                    className="flex items-start gap-2 text-xs leading-relaxed text-secondary-900/80 md:text-sm"
                  >
                    <i className="ri-checkbox-circle-line mt-0.5 flex-none text-secondary-600" />
                    {tip}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}